import React from "react"
import PropTypes from "prop-types"
import { Modal, Form, Input, Row, Col } from "antd"
import { CardNumberElement, CardExpiryElement, CardCvcElement } from "@stripe/react-stripe-js"
import { useTranslation } from "react-i18next"
import styles from "pagesV2/pro/Embedded/ExperienceBooking/ExperienceBooking.module.css"

const AddCardModal = ({ visible, onCancel, onSubmit, form, loading }) => {
  const { t } = useTranslation()
  return (
    <Modal
      title="Add Card"
      open={visible}
      onCancel={() => { form.resetFields(); onCancel() }}
      afterClose={() => form.resetFields()}
      onOk={() => onSubmit()}
      okText="Add Card"
      cancelText="Cancel"
      confirmLoading={loading}
      maskClosable={false}
      centered
    >
      <Form form={form} layout="vertical" onFinish={() => onSubmit()}>
        <Form.Item
          label={t("booking.labels.cardholder_name")}
          name="cardHolderName"
          rules={[{ required: true, message: t("booking.error_messages.card_holder_name") }]}
        >
          <Input
            placeholder="Enter full name on card"
            onChange={(e) => {
              const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, "")
              form.setFieldsValue({ cardHolderName: onlyLetters })
            }}
          />
        </Form.Item>

        <Form.Item
          label={t("booking.labels.card_number")}
          name="cardNumber"
          rules={[{ required: true, message: t("booking.error_messages.card_number") }]}
        >
          <div className={styles.stripeInputs}>
            <CardNumberElement options={{ showIcon: true }} onChange={(e) => form.setFieldsValue({ cardNumber: e.complete })} />
          </div>
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label={t("booking.labels.expiration_date")}
              name="expiry"
              rules={[{ required: true, message: t("booking.error_messages.expiry") }]}
            >
              <div className={styles.stripeInputs}>
                <CardExpiryElement onChange={(e) => form.setFieldsValue({ expiry: e.complete })} />
              </div>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={t("booking.labels.cvc")} name="cvc" rules={[{ required: true, message: t("booking.error_messages.cvc") }]}>
              <div className={styles.stripeInputs}>
                <CardCvcElement className={styles.cardInput} onChange={(e) => form.setFieldsValue({ cvc: e.complete })} />
              </div>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label={t("booking.labels.zip_code")} name="zip" rules={[{ required: true, message: t("booking.error_messages.zip") }]}>
          <Input
            placeholder="ZIP Code"
            onChange={(e) => {
              const numbersOnly = e.target.value.replace(/\D/g, "") // removes non-digits
              form.setFieldsValue({ zip: numbersOnly })
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

AddCardModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
}

export default AddCardModal
